module.exports = __webpack_public_path__ + "static/media/landing-tshirt.5fbcf07d.png";